import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Link } from 'react-router-dom';
import { push } from 'connected-react-router';
import { Row, Col, Label } from 'react-bootstrap';
import { get } from 'lodash';
import FormViewGrid from 'components/atoms/form/FormViewGrid';
import ButtonStandardCompact from 'components/atoms/buttons/compact/Primary';
import ButtonIconSecondary from 'components/molecules/buttons/ButtonIconSecondary';
import { fetchDynamicProfile, deleteDynamicProfile } from 'services/dynamicProfiles/duck';
import styled, { withTheme } from 'styled-components';
import ProtectedComponent from 'hoc/ProtectedComponent';
import { DYNAMIC_PROFILE_DELETE } from 'constants/capabilities';
import StyledReactTable from 'components/molecules/StyledReactTable';
import CellDiv from 'components/molecules/tables/components/CellDiv';
import FormSubHeading from 'components/atoms/form/FormSubHeading';
import ActiveStatusLabel from 'components/atoms/labels/ActiveStatusLabel';
import { dv360DimensionCount, innovidDimensionCount } from 'constants/platforms';

const DeleteIconButton = ProtectedComponent({
    requiredCapabilities: [DYNAMIC_PROFILE_DELETE]
})(ButtonIconSecondary);

const FieldValue = styled.div`
    color: #000;
`;

const ProfileNameHeader = styled.div`
    color: ${props => props.theme.colors.black};
    font-size: 24px;
    letter-spacing: 1px;
    line-height: 32px;
    text-transform: uppercase;
    a {
        padding-left:15px;
        font-size: 20px;
    }
`;

const buildTableData = (meta, profileType) => {
    const tableFormatData = [];
    const dimensionName = 'dimension';
    const topIndex = profileType === 'innovid' ? innovidDimensionCount : dv360DimensionCount;

    for (let index = 1; index <= topIndex; index += 1) {
        const dimension = `${dimensionName}${index}`;
        tableFormatData.push({
            dimension: `Dimension ${index}`,
            label: meta[dimension] ? meta[dimension].label : null,
            showOnReport: meta[dimension] && meta[dimension].showOnReport ? 'Show' : 'Hide' });
    }
    return tableFormatData;
};

class DynamicProfileViewContainer extends Component {
    componentDidMount() {
        const dynamicProfileId = this.props.match.params.id;
        if (this.props.fetchDynamicProfile && dynamicProfileId) {
            this.props.fetchDynamicProfile({ dynamicProfileId });
        }
    }

    render() {
        const {
            name = null,
            profileIds = [],
            meta = {},
            pivotPrimary = null,
            pivotSecondary = null
        } = this.props.dynamicProfile || {};
        const dynamicProfile = this.props.dynamicProfile;
        const profileBrand = get(dynamicProfile, 'Brand.name', null);
        const isActive = get(dynamicProfile, 'isActive', false);
        const profileType = get(dynamicProfile, 'profileType', 'dv360');
        const profileBrandId = dynamicProfile && dynamicProfile.Brand ? dynamicProfile.brandId : null;
        const tableData = buildTableData(meta, profileType);
        const pivotPrimaryDisplay = pivotPrimary ? meta[pivotPrimary].label : 'None Selected';
        const pivotSecondaryDisplay = pivotSecondary ? meta[pivotSecondary].label : 'None Selected';

        return (
            <FormViewGrid fluid>
                <ProfileNameHeader>{name}</ProfileNameHeader>
                <Row>
                    <Col md={6}>
                        <FormSubHeading>Profile Type</FormSubHeading>
                        <FieldValue>{profileType}</FieldValue>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormSubHeading>Studio Profile IDs</FormSubHeading>
                        {profileIds.map(profileId => <FieldValue>{profileId}</FieldValue>)}
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormSubHeading>Brand</FormSubHeading>
                        {!profileBrand ?
                            <FieldValue>No Associated Brand</FieldValue>
                            :
                            <Row>
                                <Col xs={6}><Link to={`/admin/brands/${profileBrandId}`}>{ profileBrand }</Link></Col>
                            </Row>}
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormSubHeading>Reporting Dimensions</FormSubHeading>

                        <StyledReactTable
                            title='Reporting Dimensions'
                            data={tableData}
                            columns={[
                                {
                                    Header: 'DIMENSION',
                                    accessor: 'dimension',
                                    Cell: row => <CellDiv value={row.value} />,
                                },
                                {
                                    Header: 'LABEL',
                                    accessor: 'label',
                                    type: 'string',
                                    Cell: row => <CellDiv value={row.value} />,
                                },
                                {
                                    Header: 'SHOW ON REPORT',
                                    accessor: 'showOnReport',
                                    type: 'string',
                                    align: 'center',
                                    Cell: row => <Label bsStyle={row.value === 'Show' ? 'info' : 'default'}>
                                        {row.value === 'Show' ? 'Shown' : 'Hidden'}
                                    </Label>

                                }
                            ]}
                            getTheadThProps={() => ({ style: { outline: 0, } })}
                            showPagination={false}
                            defaultSorted={[
                                {
                                    id: 'name'
                                }
                            ]}
                            sortable={false}
                            minRows={6}
                            className="-highlight"
                        />

                    </Col>
                </Row>
                <Row style={{ marginTop: 15 }}>
                    <Col xs={6}>
                        <FormSubHeading>Primary Pivot</FormSubHeading>
                        <FieldValue>{pivotPrimaryDisplay}</FieldValue>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <FormSubHeading>Secondary Pivot</FormSubHeading>
                        <FieldValue>{pivotSecondaryDisplay}</FieldValue>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <FormSubHeading>Active Status</FormSubHeading>
                        <ActiveStatusLabel isActive={isActive} />
                    </Col>
                </Row>
                <Row style={{ marginTop: 15 }}>
                    <Col xs={3}>
                        <ButtonStandardCompact
                            type="submit"
                            onClick={() => this.props.push(`/admin/dynamic-profiles/${this.props.match.params.id}/edit`)}>
                            Edit
                        </ButtonStandardCompact>
                    </Col>
                    <Col xs={3}>
                        <DeleteIconButton icon="trash" iconColor="#F00" onClick={() => this.props.deleteDynamicProfile(this.props.dynamicProfile)} style={{ position: 'absolute', right: 0 }}>
                            Delete
                        </DeleteIconButton>
                    </Col>
                </Row>
            </FormViewGrid>
        );
    }
}


const mapStateToProps = state => ({
    dynamicProfile: state.dynamicProfiles.dynamicProfile
});

export default compose(
    withTheme,
    connect(mapStateToProps, { fetchDynamicProfile, deleteDynamicProfile, push })
)(DynamicProfileViewContainer);



// WEBPACK FOOTER //
// ./src/containers/DynamicProfileViewContainer.js